export function formatTimeRange(start: number, duration: number): string {
  return `${start}-${start + duration} min`;
}
